import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemeListesiv2Detaylar_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemeListesiv2Detaylar_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  YuklemePlan_Get_MasterById: any[];
  YuklemePlan_Get_MasterById_dummy: any[];
  YuklemePlan_Get_DetailsByMasterId: any[];
  YuklemePlan_Get_DetailsByMasterId_dummy: any[];
  Get_Tanim_MusteriTedarikci_ById: any[];
  Get_Tanim_MusteriTedarikci_ById_dummy: any[];
  Get_Tanim_TedarikciListe: any[];
  Get_Tanim_TedarikciListe_dummy: any[];
  YuklemePlan_SaveAracDegisimTalep: number;
  YuklemePlan_SaveAracDegisimTalep_dummy: number;
  GetMailBody_TedarikciAracDEgisimTalep: string;
  GetMailBody_TedarikciAracDEgisimTalep_dummy: string;
  SendMail: boolean;
  SendMail_dummy: boolean;
  YuklemePlan_SaveUstBilgi: number;
  YuklemePlan_SaveUstBilgi_dummy: number;
  GetMailBody_YuklemeIptal: string;
  GetMailBody_YuklemeIptal_dummy: string;
  GetMailBody_YuklemeAtama: string;
  GetMailBody_YuklemeAtama_dummy: string;
  GetMailBody_TedarikciPlanGuncelleme: string;
  GetMailBody_TedarikciPlanGuncelleme_dummy: string;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  Notify: boolean;
  Notify_dummy: boolean;
  GoBack: any;
  GoBack_dummy: any;
  YuklemePlan_DeleteDetail: any[];
  YuklemePlan_DeleteDetail_dummy: any[];
  GetMailBody_TedarikciNoktaDegisiklik: string;
  GetMailBody_TedarikciNoktaDegisiklik_dummy: string;
  isComp730851Visible: "visible" | "hidden";
  isComp492008Visible: "visible" | "hidden";
  isComp535229Visible: "visible" | "hidden";
  isComp518879Visible: "visible" | "hidden";
  isComp539252Enabled: "enabled" | "disabled";
  isComp321405Enabled: "enabled" | "disabled";
  isComp370124Enabled: "enabled" | "disabled";
  isComp345115Enabled: "enabled" | "disabled";
  isComp394840Enabled: "enabled" | "disabled";
}

export class YuklemeListesiv2Detaylar_ScreenBase extends React.PureComponent<
  IYuklemeListesiv2Detaylar_ScreenProps,
  any
> {
  yuklemelistesiv2detaylar_691554_value_kuikaAutoCompleteRef: React.RefObject<any>;
  yuklemelistesiv2detaylar_63886_value_kuikaDatetimeRef: React.RefObject<any>;
  yuklemelistesiv2detaylar_394840_value_kuikaDatetimeRef: React.RefObject<any>;
  yuklemelistesiv2detaylar_559033_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "7dfc8c1f-d2ed-460f-af4a-788db3c2ab35",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 980166,
          PropertyName: "value",
          Value: "Aruna Nakliye Yönetim Portalı",
        },
        { Id: 162294, PropertyName: "value", Value: "YÜKLEME EMRİ DETAYLARI" },
        { Id: 755618, PropertyName: "value", Value: "Yükleme No" },
        { Id: 539252, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 500625, PropertyName: "value", Value: "Taşıyıcı Firma" },
        { Id: 691554, PropertyName: "placeholder", Value: "Search..." },
        { Id: 916633, PropertyName: "value", Value: "Plaka" },
        { Id: 321405, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 323894, PropertyName: "value", Value: "Araç Tipi" },
        { Id: 799315, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 317819, PropertyName: "value", Value: "Sürücü Adı" },
        { Id: 370124, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 917526, PropertyName: "value", Value: "Sürücü Gsm" },
        { Id: 345115, PropertyName: "placeholder", Value: "Type here..." },
        {
          Id: 800735,
          PropertyName: "value",
          Value: "Planlanan Yükleme Tarihi",
        },
        {
          Id: 63886,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 522070, PropertyName: "value", Value: "Tahmini Geliş Zamanı" },
        {
          Id: 394840,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 529826, PropertyName: "label", Value: "Araç Değişim Talebi" },
        { Id: 492008, PropertyName: "label", Value: "Güncelle" },
        { Id: 145261, PropertyName: "title", Value: "İşlemler" },
        { Id: 408516, PropertyName: "title", Value: "TeslimatNo" },
        { Id: 307294, PropertyName: "value", Value: "[datafield:teslimatno]" },
        { Id: 42704, PropertyName: "title", Value: "Müşteri" },
        { Id: 730621, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 619123, PropertyName: "title", Value: "Cikis Yeri" },
        {
          Id: 924550,
          PropertyName: "value",
          Value: "[datafield:cikisnoktaadi]",
        },
        { Id: 768361, PropertyName: "title", Value: "Varış Yeri" },
        {
          Id: 804461,
          PropertyName: "value",
          Value: "[datafield:varisnoktaadi]",
        },
        { Id: 621564, PropertyName: "title", Value: "Mikro Dağıtım" },
        {
          Id: 839141,
          PropertyName: "value",
          Value: "[datafield:mikrodagitimnoktaadi]",
        },
        { Id: 440379, PropertyName: "title", Value: "Ürün" },
        { Id: 14457, PropertyName: "value", Value: "[datafield:urunadi]" },
        { Id: 997454, PropertyName: "title", Value: "Palet Sayisi" },
        {
          Id: 434788,
          PropertyName: "value",
          Value: "[datafield:yuklenenpaletsayisi]",
        },
        { Id: 640986, PropertyName: "title", Value: "Koli Sayısı" },
        {
          Id: 232069,
          PropertyName: "value",
          Value: "[datafield:yuklenenkoliadedi]",
        },
        { Id: 182858, PropertyName: "title", Value: "Ağırlık" },
        {
          Id: 397042,
          PropertyName: "value",
          Value: "[datafield:yuklenenpaletagirlik]",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yuklemelistesiv2detaylar_539252_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaylar_691554_value_kuikaAutoCompleteRef =
      React.createRef();
    this.yuklemelistesiv2detaylar_321405_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaylar_799315_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaylar_370124_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaylar_345115_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaylar_63886_value_kuikaDatetimeRef =
      React.createRef();
    this.yuklemelistesiv2detaylar_394840_value_kuikaDatetimeRef =
      React.createRef();
    this.yuklemelistesiv2detaylar_559033_value_kuikaTableRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      YuklemePlan_Get_MasterById: [],
      YuklemePlan_Get_DetailsByMasterId: [],
      Get_Tanim_MusteriTedarikci_ById: [],
      Get_Tanim_TedarikciListe: [],
      YuklemePlan_SaveAracDegisimTalep: 0,
      GetMailBody_TedarikciAracDEgisimTalep: "",
      SendMail: false,
      YuklemePlan_SaveUstBilgi: 0,
      IfThenElse: false,
      Notify: false,
      GoBack: "",
      YuklemePlan_DeleteDetail: [],
      GetMailBody_TedarikciNoktaDegisiklik: "",
      isComp730851Visible: "hidden",
      isComp492008Visible: "hidden",
      isComp535229Visible: "hidden",
      isComp518879Visible: "hidden",
      isComp539252Enabled: "disabled",
      isComp321405Enabled: "disabled",
      isComp370124Enabled: "disabled",
      isComp345115Enabled: "disabled",
      isComp394840Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yuklemelistesiv2detaylar", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemeListesiv2DetaylarPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yuklemelistesiv2detaylar", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yuklemelistesiv2detaylar", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemeListesiv2DetaylarPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yuklemelistesiv2detaylar_539252_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.yuklemeNo ?? undefined,
      yuklemelistesiv2detaylar_691554_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.tasiyiciFirma ??
        undefined,
      yuklemelistesiv2detaylar_321405_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.plaka ?? undefined,
      yuklemelistesiv2detaylar_799315_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.aracTipi ?? undefined,
      yuklemelistesiv2detaylar_370124_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.surucuAdi ?? undefined,
      yuklemelistesiv2detaylar_345115_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.surucuGSM ?? undefined,
      yuklemelistesiv2detaylar_63886_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)
          ?.planlananYuklemeTarihi ?? undefined,
      yuklemelistesiv2detaylar_394840_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.tahminiGelis ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemeListesiv2DetaylarPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeListesiv2DetaylarPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeListesiv2DetaylarPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      YuklemeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      YuklemeId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].tasiyiciFirma
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].tasiyiciFirma
            : null
        ),
        "Guid"
      ),
      FirmaNo_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      UserRole_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "string"
      ),
      BagliFirmaId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
            : null
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2Detaylar/YuklemeListesiv2DetaylarPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.YuklemePlan_Get_MasterById =
      result?.data.yuklemePlan_Get_MasterById;
    formVars.yuklemelistesiv2detaylar_539252_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].yuklemeNo
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].yuklemeNo
          : null
      );
    formVars.yuklemelistesiv2detaylar_691554_options =
      stateVars.Get_Tanim_TedarikciListe;
    formVars.yuklemelistesiv2detaylar_691554_value =
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].tasiyiciFirma
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].tasiyiciFirma
        : null;
    formVars.yuklemelistesiv2detaylar_321405_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].plaka
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].plaka
          : null
      );
    formVars.yuklemelistesiv2detaylar_799315_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].aracTipi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].aracTipi
          : null
      );
    formVars.yuklemelistesiv2detaylar_370124_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].surucuAdi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].surucuAdi
          : null
      );
    formVars.yuklemelistesiv2detaylar_345115_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].surucuGSM
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].surucuGSM
          : null
      );
    formVars.yuklemelistesiv2detaylar_63886_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
        : null
    );
    formVars.yuklemelistesiv2detaylar_394840_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].tahminiGelis
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].tahminiGelis
        : null
    );
    stateVars.isComp492008Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].plaka
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].plaka
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.YuklemePlan_Get_DetailsByMasterId =
      result?.data.yuklemePlan_Get_DetailsByMasterId;

    stateVars.Get_Tanim_MusteriTedarikci_ById =
      result?.data.get_Tanim_MusteriTedarikci_ById;
    stateVars.Get_Tanim_TedarikciListe = result?.data.get_Tanim_TedarikciListe;

    formVars.yuklemelistesiv2detaylar_691554_options =
      stateVars.Get_Tanim_TedarikciListe;
    formVars.yuklemelistesiv2detaylar_691554_value =
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].tasiyiciFirma
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].tasiyiciFirma
        : null;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeListesiv2DetaylarPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2DetaylarPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yuklemelistesiv2detaylar_539252_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].yuklemeNo
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].yuklemeNo
          : null
      );

    formVars.yuklemelistesiv2detaylar_691554_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].tasiyiciFirma
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].tasiyiciFirma
          : null
      );

    stateVars.dataSource_691554 =
      stateVars.Get_Tanim_TedarikciListe ?? this.state.Get_Tanim_TedarikciListe;
    stateVars.dataSource_691554 =
      stateVars.Get_Tanim_TedarikciListe ?? this.state.Get_Tanim_TedarikciListe;
    formVars.yuklemelistesiv2detaylar_321405_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].plaka
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].plaka
          : null
      );

    formVars.yuklemelistesiv2detaylar_799315_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].aracTipi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].aracTipi
          : null
      );

    formVars.yuklemelistesiv2detaylar_370124_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].surucuAdi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].surucuAdi
          : null
      );

    formVars.yuklemelistesiv2detaylar_345115_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].surucuGSM
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].surucuGSM
          : null
      );

    formVars.yuklemelistesiv2detaylar_63886_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
        : null
    );

    formVars.yuklemelistesiv2detaylar_394840_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].tahminiGelis
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].tahminiGelis
        : null
    );

    stateVars.isComp492008Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].plaka
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].plaka
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_559033 =
      stateVars.YuklemePlan_Get_DetailsByMasterId ??
      this.state.YuklemePlan_Get_DetailsByMasterId;
    stateVars.isComp535229Visible =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.EditMode ?? this.props.screenInputs.editmode,
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp518879Visible =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.EditMode ?? this.props.screenInputs.editmode,
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemeListesiv2DetaylarComponent_491786_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "1"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.YuklemeListesiv2DetaylarComponent_491786_onClick1_,
        "YuklemeListesiv2Detaylar",
        "LeftMenu",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "29182",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeListesiv2DetaylarComponent_491786_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemeListesiv2DetaylarComponent_491786_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "YuklemeListesiv2Detaylar",
        "LeftMenuYukVeren",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "998609",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YuklemeListesiv2DetaylarComponent_529826_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      YuklemeNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].yuklemeNo
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].yuklemeNo
            : null
        ),
        "string"
      ),
      FirmaAdi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      templateId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Tanim_MusteriTedarikci_ById !== undefined
            ? stateVars.Get_Tanim_MusteriTedarikci_ById?.length > 0
              ? stateVars.Get_Tanim_MusteriTedarikci_ById[0].ePosta
              : null
            : this.state.Get_Tanim_MusteriTedarikci_ById?.length > 0
            ? this.state.Get_Tanim_MusteriTedarikci_ById[0].ePosta
            : null
        ),
        "string"
      ),
      subject_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "ARAÇ DEĞİŞİM TALEBİ",
          "string"
        ),
        "string"
      ),
      sender_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMailBody_TedarikciAracDEgisimTalep
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2Detaylar/YuklemeListesiv2DetaylarComponent_529826_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_SaveAracDegisimTalep =
      result?.data.yuklemePlan_SaveAracDegisimTalep;
    stateVars.GetMailBody_TedarikciAracDEgisimTalep =
      result?.data.getMailBody_TedarikciAracDEgisimTalep;
    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  YuklemeListesiv2DetaylarComponent_492008_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      AracTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2detaylar_799315_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PlanlananYuklemeTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2detaylar_63886_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TasiyiciFirma_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2detaylar_691554_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2Detaylar/YuklemeListesiv2DetaylarComponent_492008_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_SaveUstBilgi = result?.data.yuklemePlan_SaveUstBilgi;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2DetaylarComponent_492008_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2DetaylarComponent_492008_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].yuklemeNo
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].yuklemeNo
            : null
        ),
        "string"
      ),
      FirmaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      templateId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Tanim_MusteriTedarikci_ById !== undefined
            ? stateVars.Get_Tanim_MusteriTedarikci_ById?.length > 0
              ? stateVars.Get_Tanim_MusteriTedarikci_ById[0].ePosta
              : null
            : this.state.Get_Tanim_MusteriTedarikci_ById?.length > 0
            ? this.state.Get_Tanim_MusteriTedarikci_ById[0].ePosta
            : null
        ),
        "string"
      ),
      subject_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "YÜKLEME PLAN İPTALİ",
          "string"
        ),
        "string"
      ),
      sender_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GetMailBody_YuklemeIptal),
        "string"
      ),
      YuklemeNo_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].yuklemeNo
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].yuklemeNo
            : null
        ),
        "string"
      ),
      FirmaAdi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      templateId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2detaylar_691554_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "ePosta"
          )
        ),
        "string"
      ),
      subject_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("KYP Ataması", "string"),
        "string"
      ),
      sender_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GetMailBody_YuklemeAtama),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2Detaylar/YuklemeListesiv2DetaylarComponent_492008_onClick_if1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMailBody_YuklemeIptal = result?.data.getMailBody_YuklemeIptal;
    stateVars.SendMail = result?.data.sendMail;
    stateVars.GetMailBody_YuklemeAtama = result?.data.getMailBody_YuklemeAtama;
    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  YuklemeListesiv2DetaylarComponent_492008_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].yuklemeNo
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].yuklemeNo
            : null
        ),
        "string"
      ),
      FirmaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      templateId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Tanim_MusteriTedarikci_ById !== undefined
            ? stateVars.Get_Tanim_MusteriTedarikci_ById?.length > 0
              ? stateVars.Get_Tanim_MusteriTedarikci_ById[0].ePosta
              : null
            : this.state.Get_Tanim_MusteriTedarikci_ById?.length > 0
            ? this.state.Get_Tanim_MusteriTedarikci_ById[0].ePosta
            : null
        ),
        "string"
      ),
      subject_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "KYP Bilgi Güncellemesi",
          "string"
        ),
        "string"
      ),
      sender_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMailBody_TedarikciPlanGuncelleme
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2Detaylar/YuklemeListesiv2DetaylarComponent_492008_onClick_else1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMailBody_TedarikciPlanGuncelleme =
      result?.data.getMailBody_TedarikciPlanGuncelleme;
    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  YuklemeListesiv2DetaylarComponent_492008_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2detaylar_691554_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        ReactSystemFunctions.value(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].tasiyiciFirma
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].tasiyiciFirma
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.YuklemeListesiv2DetaylarComponent_492008_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.YuklemeListesiv2DetaylarComponent_492008_onClick_else1();
      if (isErrorOccurred) return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "1ea01eb0_bca5_f3af_1204_42decf45f680_notify",
        this.defaultML,
        "İŞLEM TAMAMLANDI"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemeListesiv2DetaylarComponent_535229_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YuklemePlanDetay",
      "YuklemeDetayId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2detaylar_559033_value",
          "yuklemeDetayId"
        ),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "YuklemePlanDetay",
      "YuklemeId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YuklemeListesiv2Detaylar",
      "YuklemePlanDetay",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "141805",
      null,
      null,
      "true",
      "800px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemeListesiv2DetaylarComponent_518879_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      OncekiNoktaSayisi_0: ReactSystemFunctions.convertToTypeByName(
        0,
        "number"
      ),
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2detaylar_559033_value",
          "id"
        ),
        "Guid"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      YuklemeDetayId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2detaylar_559033_value",
          "yuklemeDetayId"
        ),
        "Guid"
      ),
      SonrakiNoktaSayisi_0: ReactSystemFunctions.convertToTypeByName(
        0,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "8e623dd6_e27a_68ea_90f8_ce8c64aec069_confirmation",
        this.defaultML,
        "Seçilen satır Yükleme Planından çıkartılacak. Emin misiniz ?"
      ),
      "poppins",
      "",
      "",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemeListesiv2Detaylar/YuklemeListesiv2DetaylarComponent_518879_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.YuklemePlan_DeleteDetail =
        result?.data.yuklemePlan_DeleteDetail;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeListesiv2DetaylarComponent_518879_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2DetaylarComponent_518879_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].tasiyiciFirma
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].tasiyiciFirma
            : null
        ),
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_DeleteDetail !== undefined
            ? stateVars.YuklemePlan_DeleteDetail?.length > 0
              ? stateVars.YuklemePlan_DeleteDetail[0].sonuc
              : null
            : this.state.YuklemePlan_DeleteDetail?.length > 0
            ? this.state.YuklemePlan_DeleteDetail[0].sonuc
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("OK", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemeListesiv2Detaylar/YuklemeListesiv2DetaylarComponent_518879_onClick1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Tanim_MusteriTedarikci_ById =
        result?.data.get_Tanim_MusteriTedarikci_ById;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeListesiv2DetaylarComponent_518879_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeListesiv2DetaylarComponent_518879_onClick2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2DetaylarComponent_518879_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].yuklemeNo
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].yuklemeNo
            : null
        ),
        "string"
      ),
      FirmaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      MailBody_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_DeleteDetail !== undefined
            ? stateVars.YuklemePlan_DeleteDetail?.length > 0
              ? stateVars.YuklemePlan_DeleteDetail[0].sonuc
              : null
            : this.state.YuklemePlan_DeleteDetail?.length > 0
            ? this.state.YuklemePlan_DeleteDetail[0].sonuc
            : null
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_DeleteDetail !== undefined
            ? stateVars.YuklemePlan_DeleteDetail?.length > 0
              ? stateVars.YuklemePlan_DeleteDetail[0].sonuc
              : null
            : this.state.YuklemePlan_DeleteDetail?.length > 0
            ? this.state.YuklemePlan_DeleteDetail[0].sonuc
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("OK", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemeListesiv2Detaylar/YuklemeListesiv2DetaylarComponent_518879_onClick2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetMailBody_TedarikciNoktaDegisiklik =
        result?.data.getMailBody_TedarikciNoktaDegisiklik;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeListesiv2DetaylarComponent_518879_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeListesiv2DetaylarComponent_518879_onClick3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2DetaylarComponent_518879_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      templateId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Tanim_MusteriTedarikci_ById !== undefined
            ? stateVars.Get_Tanim_MusteriTedarikci_ById?.length > 0
              ? stateVars.Get_Tanim_MusteriTedarikci_ById[0].ePosta
              : null
            : this.state.Get_Tanim_MusteriTedarikci_ById?.length > 0
            ? this.state.Get_Tanim_MusteriTedarikci_ById[0].ePosta
            : null
        ),
        "string"
      ),
      subject_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Yükleme Planı Teslimat Nokta Sayısı Değişikliği",
          "string"
        ),
        "string"
      ),
      sender_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.GetMailBody_TedarikciNoktaDegisiklik
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_DeleteDetail !== undefined
            ? stateVars.YuklemePlan_DeleteDetail?.length > 0
              ? stateVars.YuklemePlan_DeleteDetail[0].sonuc
              : null
            : this.state.YuklemePlan_DeleteDetail?.length > 0
            ? this.state.YuklemePlan_DeleteDetail[0].sonuc
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("OK", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemeListesiv2Detaylar/YuklemeListesiv2DetaylarComponent_518879_onClick3_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SendMail = result?.data.sendMail;
      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [29182, 998609, 141805] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemeListesiv2DetaylarPageInit();
    }
    if (diId == 29182) {
      isErrorOccurred =
        await this.YuklemeListesiv2DetaylarComponent_491786_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
